module.exports = __webpack_public_path__ + "static/media/pembagian_kelas_ekskul.454fe05c.png";